<div class="upperSection">
  <div class="menuTitle wrapText">
    <div class="title wrapText" #userTitleEle insTooltip [cfg]="getToolTipConf(userTitleEle, userTitle)">Welcome {{userTitle}}</div>
  </div>
</div>
<div class="middleSection noFlex">
  @if (showSignOut) {
    <div class="outerEntry1" (click)="signOut()">
      <mat-icon class="lineIcon noStroke" svgIcon="signout"></mat-icon>
      Sign-Out
    </div>
  } @else {
    <div class="outerEntry1" (click)="closeApplicationTab()">
      Close {{closeViewBtnTxt}}
    </div>
  } 
</div>
<div class="bottomAlignedPanelFooter"></div>
